import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import EditEntry from "@/views/EditEntryView.vue";
import ListEntries from "@/views/ListEntries.vue";
import Settings from "@/views/SettingsView.vue";
import store from "@/store";
import { readEntriesIsEmpty } from "@/store/uniabc/getters";
import RepositoryView from "@/views/RepositoryView.vue";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "RepositoryView",
    component: RepositoryView
  },
  {
    path: "/entry",
    name: "Entry-List",
    component: ListEntries
  },
  {
    path: "/entry/:label",
    name: "Entry Test",
    component: EditEntry,
    beforeEnter(from, to, next) {
      if (readEntriesIsEmpty(store)()) {
        next("/");
      } else {
        next();
      }
    }
  },
  {
    path: "/settings",
    name: "Settings",
    component: Settings
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue")
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
